exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".highlightTrBg {\r\n    background: #f5f5f5;\r\n}\r\n.form-group {\r\n    margin-bottom: 25px;\r\n}\r\n.md-small {\r\n    width: 20px;\r\n    height: 25px;\r\n    padding: 0px;\r\n    font-size: 12px;\r\n    line-height: 20px;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/UI-PROJECTS/Helpline1097-UI/src/app/reallocate-calls/reallocate-calls.component.css
// module id = ../../../../../src/app/reallocate-calls/reallocate-calls.component.css
// module chunks = 0